module.exports = __webpack_public_path__ + "static/yum_body_img1-3929bfda3a604e6976e0df7c0646864a.png";